import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21v-4","key":"svg-0"}],["path",{"d":"M12 13v-4","key":"svg-1"}],["path",{"d":"M12 5v-2","key":"svg-2"}],["path",{"d":"M10 21h4","key":"svg-3"}],["path",{"d":"M8 5v4h11l2 -2l-2 -2z","key":"svg-4"}],["path",{"d":"M14 13v4h-8l-2 -2l2 -2z","key":"svg-5"}]]

const IconDirections = createReactComponent('outline', 'directions', 'Directions', __iconNode);

export default IconDirections;